import { DomainConfig } from '@/config/domain'
import { getObjectFromStorage, setObjectToStorage } from '@/utils/localStorage'
import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react'

type Tenant = DomainConfig
type TenantContextType = {
  currentTenant: Tenant | null
  selectedTenant: Tenant | null
  setCurrentTenant: Dispatch<SetStateAction<Tenant | null>>
  setSelectedTenant: Dispatch<SetStateAction<Tenant | null>>
}
const TenantContext = createContext<TenantContextType | null>(null)

type TenantProviderProps = {
  children: ReactNode
}

export const TenantProvider = ({ children }: TenantProviderProps) => {
  const [currentTenant, setCurrentTenantState] = useState<Tenant | null>(null)
  const [selectedTenant, setSelectedTenantState] = useState<Tenant | null>(null)

  useEffect(() => {
    const storedTenant = getObjectFromStorage<Tenant>('currentTenant')
    const storedSelectedTenant = getObjectFromStorage<Tenant>('selectedTenant')

    if (storedTenant) {
      setCurrentTenantState(storedTenant)
    }

    if (storedSelectedTenant) {
      setSelectedTenantState(storedSelectedTenant)
    }
  }, [])

  const setCurrentTenant: Dispatch<SetStateAction<Tenant | null>> = value => {
    setCurrentTenantState(prev => {
      const newTenant = typeof value === 'function' ? value(prev) : value
      setObjectToStorage('currentTenant', newTenant)
      return newTenant
    })
  }

  const setSelectedTenant: Dispatch<SetStateAction<Tenant | null>> = value => {
    setSelectedTenantState(prev => {
      const newTenant = typeof value === 'function' ? value(prev) : value
      setObjectToStorage('selectedTenant', newTenant)
      return newTenant
    })
  }

  return (
    <TenantContext.Provider
      value={{
        currentTenant,
        selectedTenant,
        setSelectedTenant,
        setCurrentTenant
      }}
    >
      {children}
    </TenantContext.Provider>
  )
}

export const useTenantContext = () => {
  const context = useContext(TenantContext)

  if (!context) {
    throw new Error('useTenantContext deve ser usado dentro de um TenantProvider')
  }

  return context
}
